import React, { useContext, useState } from 'react'

import { useMutation } from '@apollo/client'

import { Delete } from 'tools/Modal/Confirm'
import notify, { readableError } from 'tools/Notify'
import { Label } from 'tools/Uniform'
import { strcmp } from 'utils/string'

import { LOAD_ORG, MUTATE_ORG_MEMBER } from '../graphql'
import OrgContext from '../reducer'
import { SelectRole } from './'

function sortMembers(a, b) {
  return strcmp(a.user?.name, b.user?.name)
}

export function Show({ canChange }) {
  const [org] = useContext(OrgContext)

  return (
    <table className="list w-100">
      <thead>
        <tr>
          <th className="pl2">Name</th>
          <th>Role</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {org.members.toSorted(sortMembers).map((mbr) => (
          <MemberRow key={mbr.id} mbr={mbr} canChange={canChange} />
        ))}
      </tbody>
    </table>
  )
}

function MemberRow({ mbr, canChange }) {
  const [edit, setEdit] = useState(false)
  const NUM_COLS = 3
  const className = `pointer ${edit ? 'bg-hilite' : ''}`

  return (
    <>
      <tr className={className} onClick={() => setEdit(!edit)}>
        <td className="pl2">{mbr.user.name}</td>
        <td>{mbr.role}</td>
        {canChange && (
          <td className="flex justify-end">
            <div>
              <i
                className={
                  edit ? 'fas fa-square-minus' : 'gray fas fa-square-plus'
                }
              />
            </div>
          </td>
        )}
      </tr>
      {edit && (
        <tr className="no-hover">
          <td colSpan={NUM_COLS} className="pl2 pv3 base-frame">
            <Edit member={mbr} />
          </td>
        </tr>
      )}
    </>
  )
}

function changeOrg(mutator, notifyD, variables, refetchQueries = null) {
  return mutator({
    variables,
    onCompleted({ orgChange: resp }) {
      if (!resp?.success) {
        notify.error(notifyD, readableError(resp?.reason))
      }
    },
    refetchQueries
  })
}

function Edit({ member }) {
  const [org] = useContext(OrgContext)

  const [mutator] = useMutation(MUTATE_ORG_MEMBER)
  const [, notifyD] = useContext(notify.Context)

  const changeRole = (role) =>
    changeOrg(mutator, notifyD, { action: 'CHANGE_ROLE', id: member.id, role })
  const deleteMember = () =>
    changeOrg(mutator, notifyD, { action: 'REMOVE', id: member.id }, [
      { query: LOAD_ORG, variables: { id: org.id } }
    ])

  return (
    <div className="flex justify-between items-center gh2 gv2 ">
      <Label>Role:</Label>
      <SelectRole role={member.role} onChange={changeRole} />
      <Delete
        className="ml-auto mh2 large neutral"
        title={`Remove ${member.user.name} from ${org.name}?`}
        onConfirm={deleteMember}
        label="Remove"
        labelIcon=""
      />
    </div>
  )
}

export default Show
